import { render } from "./ServicePoste.vue?vue&type=template&id=dc2bbdee&ts=true"
import script from "./ServicePoste.vue?vue&type=script&lang=ts"
export * from "./ServicePoste.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__